import React, { useState, FormEvent, FocusEvent, Dispatch, SetStateAction } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { DriveUIActionTypes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
    active: boolean;
    paused: boolean;
    loading: boolean;
    search_term?: string;
    setSearchTerm: Dispatch<SetStateAction<string>>;
    handleAction: ActionHandlerFunction;
}

function SearchFormComponent(props: AllProps) {
    const { search_term, active, paused, loading, setSearchTerm, handleAction } = props;
    const [local_search_term, setLocalSearchTerm] = useState<string>(search_term || "");
    // Disable text box if there is a search term
    const is_searching = active && loading && !paused;

    // Description: Submit Search for Drive
    function handleSubmit(e: FormEvent<HTMLFormElement>) {
        setSearchTerm(local_search_term.trim());
        e.preventDefault();
        e.stopPropagation();
    };

    // Description: Handle Click of X on the textbox
    function handleReset() {
        setLocalSearchTerm("");
        active && handleAction({ actionType: DriveUIActionTypes.Reset, params: { pause: true } });
    }

    return <Form noValidate onSubmit={handleSubmit} >
        <Form.Label htmlFor="search_drive" visuallyHidden>Search My PreVeil</Form.Label>
        <InputGroup>
            <Form.Control
                id="search_drive"
                disabled={is_searching}
                className={is_searching ? "text-muted cursor-block" : ""}
                name="search_drive"
                autoComplete="off"
                placeholder="Search by item name..."
                aria-label="Search by item name..."
                value={local_search_term}
                onChange={(e: FocusEvent<HTMLInputElement>) => setLocalSearchTerm((e.currentTarget.value))} />
            <Button variant="icon"
                disabled={!local_search_term}
                className={!local_search_term ? "opacity-0" : ""}
                onClick={handleReset}>
                <Icon className="ficon-x" />
            </Button>
            <Button variant="icon"
                type="submit"
                disabled={!local_search_term}
                className={(is_searching || !local_search_term) ? "text-muted-light" : ""}>
                <Icon className="ficon-search" /></Button>
        </InputGroup>
    </Form>;
}

export default React.memo(SearchFormComponent);
